document.documentElement.classList.remove('no-js');

function initSlideshow(root) {
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const slides = Array.from(root.querySelectorAll('[data-slide]'));
  const progress = Array.from(root.querySelectorAll('[data-slide-dot]'));
  const counter = root.querySelector('[data-slide-counter]');
  const pause = root.querySelector('[data-slide-pause]');
  const delay = Number(root.dataset.autoplayDelay || 5200);
  let index = 0;
  let paused = root.dataset.autoplay !== 'true';
  let timer;

  if (!slides.length) return;

  function show(next) {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    progress.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    schedule();
  }

  function schedule() {
    window.clearTimeout(timer);
    if (!paused) timer = window.setTimeout(() => show(index + 1), delay);
  }

  root.querySelector('[data-slide-previous]')?.addEventListener('click', () => show(index - 1));
  root.querySelector('[data-slide-next]')?.addEventListener('click', () => show(index + 1));
  progress.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));
  pause?.addEventListener('click', () => {
    paused = !paused;
    pause.textContent = paused ? '▶' : 'Ⅱ';
    pause.setAttribute('aria-label', paused ? 'Resume automatic slideshow' : 'Pause automatic slideshow');
    schedule();
  });

  root.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') show(index - 1);
    if (event.key === 'ArrowRight') show(index + 1);
  });

  show(0);
}

function initTheme(scope = document) {
  scope.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
}

document.addEventListener('DOMContentLoaded', () => initTheme());
document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
